<template>
    <tr class="savingsdata">
        <td>
            <div class="savingssubdiv">{{ label }}: Heating: {{ heating_setback }}&deg;, Cooling: {{ cooling_setback }}&deg;</div>
        </td>
    </tr>
</template>
<script>
    export default {

        props: ['projectMeasure', 'label', 'value_field', 'fieldExtra'],

        computed: {
            heating_setback() {

                if(typeof this.projectMeasure[this.value_field] !== 'object' || !this.projectMeasure[this.value_field] || !this.projectMeasure[this.value_field].heating_setback) {
                    return 'TBD';
                }

                return this.projectMeasure[this.value_field].heating_setback;
            },
            cooling_setback() {

                if(typeof this.projectMeasure[this.value_field] !== 'object' || !this.projectMeasure[this.value_field] || !this.projectMeasure[this.value_field].cooling_setback) {
                    return 'TBD';
                }

                return this.projectMeasure[this.value_field].cooling_setback;

            }
        }


    }
</script>
